


import PrintEpaysageAlt from './PrintEpaysageAlt';




export default function MultiPrintEpaysage({ printDataList, inventaireIds, inventaires }: { printDataList: any, inventaireIds: number[], inventaires: any }) {








  return (
    <div className={`bg-white `}>
      {/* Print Controls - Hidden when printing */}

      {/* Main Print Content */}
      <div className="print-container">
        {printDataList.map((printData: any, index: number) => {

          return (
            <div
              key={inventaireIds[index] || inventaires[index]?.id || index}
              className={index > 0 ? 'page-break-before' : ''}
            >
              <PrintEpaysageAlt
                inventaireId={inventaireIds[index] || inventaires[index]?.id || index}
                printData={printData}
              />
            </div>
          );
        })}
      </div>


    </div>
  );
}
